import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressBar", "progressLegend", "progressText"]
  static values = {
    id: Number,
    lines: Number,
    finished: Boolean,
    path: String,
    destination: String,
  }

  connect() {
    // Don't start polling if the import is already finished
    if (this.hasFinishedValue && this.finishedValue) {
      return
    }

    if (!this.hasIdValue || !this.hasPathValue) return

    this.startTime = new Date()
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.pollId = setInterval(() => this.fetchProgress(), 2000)
  }

  stopPolling() {
    if (this.pollId) clearInterval(this.pollId)
  }

  fetchProgress() {
    const url = this.pathValue

    fetch(`${url}?t=${new Date().getTime()}`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          this.stopPolling()
          return null
        }
        return response.json()
      })
      .then((json) => {
        if (!json) return

        const { percentage, processed_rows } = json.progress

        // Update progress bar
        if (this.hasProgressBarTarget) {
          this.progressBarTarget.style.width = `${percentage}%`
          this.progressBarTarget.setAttribute("aria-valuenow", percentage)
        }

        // Update progress text
        if (this.hasProgressTextTarget) {
          this.progressTextTarget.innerHTML = processed_rows
        }

        // Update progress legend with percentage and estimated time
        if (this.hasProgressLegendTarget) {
          if (percentage === 0) {
            this.progressLegendTarget.innerHTML = `${percentage}%`
            return
          }

          // Calculate time remaining (rough estimate)
          const elapsedMs = new Date() - this.startTime
          const remainingPercentage = 100 - percentage
          const timePerPercent = elapsedMs / percentage
          const estimatedMsLeft = remainingPercentage * timePerPercent

          let timeText = ""
          if (estimatedMsLeft > 60000) {
            timeText = `${Math.ceil(estimatedMsLeft / 60000)} min. left`
          } else {
            timeText = `${Math.ceil(estimatedMsLeft / 1000)} sec. left`
          }

          this.progressLegendTarget.innerHTML = `${percentage}% · ${timeText}`
        }

        if (percentage >= 100) {
          this.stopPolling()
          this.handleCompletion()
        }
      })
      .catch(() => {
        this.stopPolling()
      })
  }

  handleCompletion() {
    if (this.hasDestinationValue && this.destinationValue) {
      setTimeout(() => {
        window.location.href = this.destinationValue
      }, 500)
    } else {
      setTimeout(() => {
        window.location.reload()
      }, 500)
    }
  }
}
